<template>
<div
    class="searchbar"
    :class="{ 'searchbar-open': open, 'searchbar-mobile': mobile }"
    @keydown="handleKeydown"
>
    <input
        ref="input"
        class="search-input"
        v-model="query"
        placeholder="Искать аниме, фильмы и сериалы..."
        aria-label="Поиск аниме, фильмов и сериалов"
        @input="search"
    >
    <button type="button" class="search-close" aria-label="Закрыть поиск" @click="close">
        <img src="@/assets/close.svg" alt="">
    </button>

    <div class="results" v-if="query.trim()" aria-live="polite">
        <SearchSection
            v-for="(section, index) in get_media_search_sections"
            :key="section.id"
            :section="section"
            :divided="index > 0"
            @select="selectResult"
        />
    </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SearchSection from '@/components/Search/SearchSection.vue'

const MIN_SEARCH_LENGTH = 2

export default {
    name: 'searchbar',
    components: { SearchSection },
    props: {
        mobile: Boolean,
        open: Boolean
    },
    emits: ['close'],
    data() {
        return {
            query: '',
            searchTimer: null
        }
    },
    computed: mapGetters(['get_media_search_sections']),
    methods: {
        ...mapActions(['search_media', 'invalidate_media_search']),
        search() {
            clearTimeout(this.searchTimer)
            this.invalidate_media_search()
            let title = this.query.trim()

            if (title.length < MIN_SEARCH_LENGTH) return

            this.searchTimer = setTimeout(() => {
                this.search_media(title)
            }, 300)
        },
        close() {
            clearTimeout(this.searchTimer)
            this.query = ''
            this.invalidate_media_search()
            this.$emit('close')
        },
        handleKeydown(event) {
            if (event.key !== 'Escape' && Number(event.keyCode) !== 461) return
            event.preventDefault()
            event.stopPropagation()
            this.close()
        },
        selectResult() {
            clearTimeout(this.searchTimer)
            this.query = ''
            this.invalidate_media_search()
        },
        focusInput() {
            if (this.$refs.input) this.$refs.input.focus()
        }
    },
    beforeUnmount() {
        clearTimeout(this.searchTimer)
        this.invalidate_media_search()
    }
}
</script>

<style scoped>
.searchbar {
    position: absolute;
    z-index: 3;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    inset: 0;
    width: 100%;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transform: translateY(-7px) scale(0.98);
    transition: opacity 180ms ease, transform 220ms ease, visibility 220ms;
}
.searchbar-open {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transform: translateY(0) scale(1);
}
.search-input {
    width: 100%;
    height: 52px;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 26px;
    outline: none;
    background: rgba(28, 28, 28, 0.96);
    color: #fff;
    font-family: Inter, sans-serif;
    font-size: 16px;
    padding: 0 52px 0 22px;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
}
.search-input:focus-visible {
    border-color: rgba(255, 255, 255, 0.55);
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.14);
}
.search-close {
    position: absolute;
    top: 14px;
    right: 17px;
    width: 24px;
    height: 24px;
    display: grid;
    place-items: center;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
}
.search-close img {
    width: 14px;
    height: 14px;
}
.results {
    margin-top: 8px;
    max-height: 470px;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    background: rgba(28, 28, 28, 0.97);
    padding: 12px;
    overflow-y: auto;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
}
@media (max-width: 1000px) {
    .searchbar-mobile {
        position: relative;
        inset: auto;
        width: 100%;
        min-height: calc(100vh - 76px);
        min-height: calc(100dvh - 76px);
        padding: 10px;
        padding-bottom: calc(92px + env(safe-area-inset-bottom, 0px));
        box-sizing: border-box;
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
        transform: none;
    }
    .searchbar-mobile .search-input {
        height: 47px;
        border-radius: 0 0 8px 8px;
        padding-right: 22px;
        -webkit-backdrop-filter: none;
        backdrop-filter: none;
    }
    .searchbar-mobile .search-close { display: none; }
    .searchbar-mobile .results {
        max-height: none;
        border-radius: 8px;
        overflow: visible;
        -webkit-backdrop-filter: none;
        backdrop-filter: none;
    }
}
@media (min-width: 1001px) {
    .searchbar-mobile { display: none; }
}
@media (prefers-reduced-motion: reduce) {
    .searchbar { transition: none; }
}
</style>
